import { language } from '@/ui/dictionary';
import { locales, supportedLocales, formLocales, supportedFormLocales } from '@/ui/i18n/i18n';

const mapLangs = <T extends locales | formLocales>(code: T) => ({
  label: language(code),
  value: code as T,
});

export const supportedLocalesOptions = () => supportedLocales.map(mapLangs<locales>);

export const supportedFormLocalesOptions = () => supportedFormLocales.map(mapLangs<formLocales>);
